import { request } from "./client";
import USE_MOCK from "../mock/config";
import {
  mockFetchTenantConfigs,
  mockUpdateTenantConfig,
} from "../mock/mockHandlers";

const tenantConfigsPath = (tenantId) => `/tenants/${tenantId}/configs`;

export const fetchTenantConfigs = (tenantId) =>
  USE_MOCK ? mockFetchTenantConfigs(tenantId) : request(tenantConfigsPath(tenantId));
export const updateTenantConfigs = (tenantId, payload) =>
  USE_MOCK ? mockUpdateTenantConfig(tenantId, payload) : request(tenantConfigsPath(tenantId), { method: "PUT", data: payload });
